// src/components/layout/NavLink.tsx
// ============================================================
// Summit League v2 — NavLink
// Wraps React Router's NavLink with sl- class conventions.
// ============================================================

import React from 'react';
import { NavLink as RouterNavLink } from 'react-router-dom';

interface NavLinkProps {
  to: string;
  exact?: boolean;
  className?: string;
  onClick?: () => void;
  children: React.ReactNode;
}

/**
 * NavLink component that auto-applies active/inactive classes
 * based on the current route via React Router v6.
 */
export default function NavLink({
  to,
  exact = false,
  className = '',
  onClick,
  children,
}: NavLinkProps) {
  return (
    <RouterNavLink
      to={to}
      end={exact}
      onClick={onClick}
      className={({ isActive }) =>
        [
          'sl-nav-link',
          isActive ? 'sl-nav-link--active' : 'sl-nav-link--inactive',
          className,
        ]
          .filter(Boolean)
          .join(' ')
      }
    >
      {children}
    </RouterNavLink>
  );
}
